module.exports = "/images/tiktok.svg";